import { toggleShowDeclinedEventsMode } from '../actions/toggleShowDeclinedEventsMode';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import setUserConfiguration from 'owa-session-store/lib/actions/setUserConfiguration';
import { lazyUpdateUserConfigurationService } from 'owa-update-user-configuration-service';
import { orchestrator } from 'satcheljs';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';

orchestrator(toggleShowDeclinedEventsMode, async actionMessage => {
    const { isDeclinedEventsMode } = actionMessage;

    let userConfig = getUserConfiguration();
    setUserConfiguration({
        ...userConfig,
        ViewStateConfiguration: {
            ...userConfig.ViewStateConfiguration,
            CalendarViewShowDeclinedMeetings: isDeclinedEventsMode,
        },
    });

    lazyUpdateUserConfigurationService.importAndExecute(
        VIEW_STATE_CONFIGURATION,
        {
            // Key
            Type: 'String',
            Value: ['CalendarViewShowDeclinedMeetings'],
        },
        {
            // Value
            Type: 'Boolean',
            Value: [`${isDeclinedEventsMode}`],
        }
    );
});
